import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { SVGIcon } from '../icons/svg-icon';

@Component({
  tag: 'opti-profile-dropdown',
  styleUrl: 'opti-profile-dropdown.scss',
  shadow: true,
})
export class OptiProfileDropdown {
  @Prop({ mutable: true })
  user?: { email: string; name: string; preferred_username?: string };

  @Event({
    eventName: '@opti-profile-dropdown:logout',
    composed: true,
    bubbles: true,
    cancelable: true,
  })
  logout: EventEmitter;

  getUserInitials() {
    const { name } = this.user || {};
    const fullName = name?.split(' ');
    const lastInitial = fullName?.pop().split('')[0].toUpperCase();
    const firstInitial = fullName?.shift().split('')[0].toUpperCase();
    return firstInitial ? `${firstInitial}${lastInitial}` : '';
  }

  signOut = () => {
    this.logout.emit();
  };

  render() {
    const { email, name } = this.user || {};
    const userInitials = this.getUserInitials();

    return (
      <div class="profile-dropdown-container" tabIndex={0}>
        <button class="avatar">
          {userInitials ? (
            userInitials
          ) : (
            <div class="avatar__icon">
              <SVGIcon name="user"></SVGIcon>
            </div>
          )}
        </button>
        <div class="profile-dropdown" id="profile-dropdown-menu">
          <div class="menu">
            <ul>
              {name && email && (
                <li class="list-item-header" title={name}>
                  <span class="name">{name}</span>
                  <br />
                  <span class="email" title={email}>
                    {email}
                  </span>
                </li>
              )}
              <li class="list-item">
                <a class="list-item-link" id="logout" onClick={this.signOut}>
                  <span class="list-item-icon">
                    <SVGIcon name="arrow-right-from-bracket"></SVGIcon>
                  </span>
                  Log Out
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
